/* global axios */

const DEFAULT_API_VERSION = 'v1';

class ApiClient {
  constructor(resource, options = {}) {
    this.apiVersion = `/api/${options.apiVersion || DEFAULT_API_VERSION}`;
    this.options = options;
    this.resource = resource;
  }

  get url() {
    return `${this.baseUrl()}/${this.resource}`;
  }

  baseUrl() {
    let url = this.apiVersion;
    if (this.options.accountScoped) {
      const isInsideAccountScopedURLs = window.location.pathname.includes(
        '/app/accounts'
      );

      if (isInsideAccountScopedURLs) {
        const accountId = window.location.pathname.split('/')[3];
        url = `${url}/accounts/${accountId}`;
      }
    }

    return url;
  }

  get() {
    return axios.get(this.url);
  }

  getAvailability() {
    return axios.get(`${this.url}/get_availability`);
  }

  getAccountsAvailability(){
    return axios.get(`${this.url}/get_accounts_availability`);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
      try {
          return axios.post(this.url, data, {
              headers: {
                  'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              }
          })
      }catch (error) {
          throw new Error(error);
      }
  }

  applyLable(data){
    return axios.post(`${this.url}/apply_labels_to_contacts`, data)
  }

  exportAccountContacts(data){
    return axios.post(`${this.url}/export_account_contacts`, data)
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default ApiClient;
